// src/theme/tokens/focusRing.js
// Faz 1 · Tutarli focus ring sistemi (WCAG AA+).
// Mevcut focusOutlineAccent/Purple/Error korunur; bu yeni katman onlari konsolide eder.
// Faz 2'de tum interactive component override'larina default _focusVisible olarak baglanir.

const focusRingTokens = {
  // ===== STANDART (en yaygin kullanim) =====
  'focusRing.default': {
    default: '0 0 0 3px var(--chakra-colors-brand-500_alpha_40)',
    _dark:   '0 0 0 3px var(--chakra-colors-brand-300_alpha_40)',
  },

  // ===== HIGH CONTRAST (WCAG AAA, light/dark backdrop ayirt edilir) =====
  // Cift halka: ic 2px white/dark (separator), dis 2px brand.
  'focusRing.contrast': {
    default: '0 0 0 2px var(--chakra-colors-white), 0 0 0 4px var(--chakra-colors-brand-600)',
    _dark:   '0 0 0 2px var(--chakra-colors-slate-900), 0 0 0 4px var(--chakra-colors-brand-300)',
  },

  // ===== ERROR (form validation, destructive action) =====
  'focusRing.error': {
    default: '0 0 0 3px var(--chakra-colors-rose-500_alpha_40)',
    _dark:   '0 0 0 3px var(--chakra-colors-rose-300_alpha_40)',
  },

  // ===== SUCCESS (basari tonlu form) =====
  'focusRing.success': {
    default: '0 0 0 3px var(--chakra-colors-emerald-500_alpha_25)',
    _dark:   '0 0 0 3px var(--chakra-colors-emerald-300_alpha_30)',
  },

  // ===== WARNING (dikkat tonlu eylem) =====
  'focusRing.warning': {
    default: '0 0 0 3px var(--chakra-colors-amber-500_alpha_25)',
    _dark:   '0 0 0 3px var(--chakra-colors-amber-300_alpha_30)',
  },

  // ===== SUBTLE (link vb. inline elemanlar · daha az vurgulu) =====
  'focusRing.subtle': {
    default: '0 0 0 2px var(--chakra-colors-brand-500_alpha_25)',
    _dark:   '0 0 0 2px var(--chakra-colors-brand-300_alpha_30)',
  },

  // ===== INSET (icerik yogun container'lar · tasmadan ic gosterim) =====
  'focusRing.inset': {
    default: 'inset 0 0 0 2px var(--chakra-colors-brand-500_alpha_40)',
    _dark:   'inset 0 0 0 2px var(--chakra-colors-brand-300_alpha_40)',
  },
};

export default focusRingTokens;
